import { forwardRef, type ComponentProps, type ReactNode } from 'react';
import { tv } from 'tailwind-variants';

const classes = tv({
  slots: {
    row: 'w-full h-[3.6rem] px-[1.2rem] flex items-center gap-[0.8rem] rounded-[1.2rem] text-primary cursor-pointer hover:bg-secondary-bg data-[state=open]:bg-secondary-bg data-[state=open]:rounded-[0.8rem] transition-colors text-left',
    icon: 'size-[1.6rem] shrink-0 flex items-center justify-center [&>svg]:size-[1.6rem]',
    label: 'medium5 flex-1 truncate',
    right: 'flex items-center gap-[0.4rem] p6 text-secondary shrink-0',
  },
  variants: {
    destructive: {
      true: {
        row: 'text-red hover:text-red',
      },
    },
  },
});

type Props = ComponentProps<'button'> & {
  icon: ReactNode;
  label: string;
  right?: ReactNode;
  destructive?: boolean;
};

export const MenuRow = forwardRef<HTMLButtonElement, Props>(
  ({ icon, label, right, destructive = false, className, ...props }, ref) => {
    const c = classes({ destructive });

    return (
      <button
        ref={ref}
        type="button"
        className={c.row({ className })}
        {...props}>
        <span className={c.icon()}>{icon}</span>
        <span className={c.label()}>{label}</span>
        {right && <span className={c.right()}>{right}</span>}
      </button>
    );
  }
);

MenuRow.displayName = 'MenuRow';
